import { createReducer } from "../helpers/create-reducer";
import { setIn, getIn } from "lodash-redux-immutability";

const actions = {
    "NOTIFICATIONS.CONSOLE.ADD": (state, { payload }) => {
        const { user, message } = payload;
        const context = payload.context || {};
        const { id, task_id, status, created_at } = context;
        const path = ["notifications", id];
        const prev = getIn(state, path);
        const nextStatus = id === task_id ? status : prev?.status;
        const withErrors = status === "fail" || prev?.error;
        const isSubtask = task_id !== id;

        if (isSubtask) {
            return setIn(state, path, {
                ...prev,
                status: nextStatus,
                error: withErrors,
                log: setIn(prev.log, [task_id], {
                    message,
                    status,
                    ...context,
                }),
            });
        }

        if (!prev) {
            return setIn(state, path, {
                id,
                message,
                status: nextStatus,
                error: withErrors,
                created_at,
                log: {},
            });
        }

        return setIn(state, path, {
            ...prev,
            status:
                withErrors && nextStatus === "success" ? "fail" : nextStatus,
            error: withErrors && nextStatus !== "pending",
        });
    },
};
export default createReducer(
    {
        notifications: {},
    },
    actions
);
